import r from "./index283.js";
import { resolveComponent as t, createElementBlock as n, openBlock as c, createVNode as s } from "vue";
/* empty css         */
import a from "./index231.js";
const i = ["data-component"];
function p(o, l, m, d, _, u) {
  const e = t("ms-chevron");
  return c(), n("div", {
    "data-component": o.$options.name,
    class: "flex items-center justify-center border border-solid rounded-full cursor-pointer ui-custom-size border-color-neutral-white hover:bg-color-neutral-black"
  }, [
    s(e, { class: "w-24 h-24 text-color-neutral-white" })
  ], 8, i);
}
const $ = /* @__PURE__ */ a(r, [["render", p], ["__scopeId", "data-v-34359f32"]]);
export {
  $ as default
};
